module.exports = __webpack_public_path__ + "img/lte.56963dad.jpg";